import { AppEnvironment } from '../../enums/appEnvironment.enum'
import type { Environment } from '../config.type'

export function detectEnvironment(): Environment {
  switch (process.env.NEXT_PUBLIC_APP_ENV) {
    case AppEnvironment.DEV:
      return 'dev'
    case AppEnvironment.TEST:
      return 'test'
    case AppEnvironment.PROD:
    default:
      return 'production'
  }
}
